const rankings = [
  {
    rank: 1,
    title: '顶流男星深夜酒店私会神秘女子，这是第几个了？',
    heat: '🔥 203万热度',
    change: 'up',
    changeNum: '↑ 12位',
  },
  {
    rank: 2,
    title: '知名导演新片选角黑幕：投资方内定女主角实锤',
    heat: '🔥 178万热度',
    change: 'up',
    changeNum: '↑ 5位',
  },
  {
    rank: 3,
    title: '偶像团体成员被曝恋爱多年，粉丝后援会集体脱粉',
    heat: '🔥 156万热度',
    change: 'up',
    changeNum: '↑ 23位',
  },
  {
    rank: 4,
    title: '女星整容对比图疯传，网友直呼判若两人',
    heat: '127万热度',
    change: 'down',
    changeNum: '↓ 3位',
  },
  {
    rank: 5,
    title: '直播一哥供应链造假，品牌方集体解约涉数亿元',
    heat: '115万热度',
    change: 'new',
    changeNum: '新上榜',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热搜榜单
            </h2>
            <p className="text-sm text-foreground-500">实时追踪全网最热门爆料话题排行榜</p>
          </div>
          <div className="space-y-3">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
              >
                {/* Rank number */}
                <div className="flex-shrink-0 w-10 text-center">
                  {item.rank === 1 ? (
                    <div className="w-8 h-8 mx-auto rounded-lg bg-accent-500 flex items-center justify-center">
                      <i className="ri-trophy-line text-white text-sm"></i>
                    </div>
                  ) : item.rank === 2 ? (
                    <div className="w-8 h-8 mx-auto rounded-lg bg-accent-300 flex items-center justify-center">
                      <i className="ri-medal-line text-white text-sm"></i>
                    </div>
                  ) : item.rank === 3 ? (
                    <div className="w-8 h-8 mx-auto rounded-lg bg-accent-200 flex items-center justify-center">
                      <i className="ri-medal-line text-accent-700 text-sm"></i>
                    </div>
                  ) : (
                    <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-0.5">{item.heat}</p>
                </div>

                {/* Change indicator */}
                <div className="flex-shrink-0">
                  <span
                    className={`text-xs font-medium px-2 py-1 rounded-md ${
                      item.change === 'up'
                        ? 'text-primary-500 bg-primary-50'
                        : item.change === 'down'
                        ? 'text-foreground-400 bg-background-100'
                        : 'text-accent-500 bg-accent-50'
                    }`}
                  >
                    {item.changeNum}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}